import axios from 'axios';

const url = process.env.VUE_APP_HOST;
const home = process.env.VUE_APP_HOME;
const wid = process.env.VUE_APP_TYPE;

const getEventTemplate = async function (id){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`
        }
    };
    let urlWithArg = url + 'api/EventTemplate/' + id;

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}

const getEventTemplates = async function (isAdmin = false){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`
        }
    };
    let urlWithArg = url + 'api/EventTemplate?wid='+ wid +'&isAdmin=' + isAdmin;

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}

const postEventTemplate = async function (payload){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/EventTemplate';

    let result = await axios.post(urlWithArg,JSON.stringify(payload), headers);
    
    return result.data;

}


const patchEventTemplate = async function (payload){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`,
           'Content-Type': 'application/json'
        }
    };
    let urlWithArg = url + 'api/EventTemplate/'+payload.Identity;

    let result = await axios.patch(urlWithArg, JSON.stringify(payload), headers);
    
    return result.data;

}

const delEventTemplate = async function (id){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`
        }
    };
    let urlWithArg = url + 'api/EventTemplate/'+id;

    let result = await axios.delete(urlWithArg, headers);
    
    return result.data;

}


export const eventTemplateService = { getEventTemplate, getEventTemplates, postEventTemplate, patchEventTemplate, delEventTemplate }


// WEBPACK FOOTER //
// ./src/api/event-template.service.js